/**
 * @fileoverview PHARMAKON — Sujets temps réel : le bus côté web des sujets d'invalidation SSE.
 * @module services/sujetsTempsReel
 *
 * Cross-module X XA-09 (Trésorerie ADR-11 « generalised to topics »). Le flux par officine
 * (`/alertes-equipe/stream`, ouvert UNE fois par `alerteStore`) transporte, en plus des alertes
 * d'équipe, des trames `event: sujet` — `{ sujet, …pointeur, at }`, jamais un contenu. Ce module
 * les redistribue aux écrans montés qui les écoutent (ex. Vente CHIFA sur `chifa:facture:<poste>`),
 * sans ouvrir un second flux.
 *
 * CE N'EST PAS LE CHEMIN DE CORRECTION : un événement perdu est rattrapé par le plancher de
 * l'écran (GET conditionnel, 304 quand rien n'a changé). Quand le serveur ordonne un `resync`
 * (tampon dépassé), chaque écouteur reçoit `{ resync: true }` et relit ce qu'il affiche.
 */

const ecouteurs = new Set();

/**
 * Écoute les sujets commençant par `prefixe` (sujet exact ou famille, ex. « chifa:facture: »).
 * @param {string} prefixe
 * @param {(evt: { sujet: string|null, resync: boolean, data: object|null }) => void} rappel
 * @returns {() => void} désabonnement
 */
export function ecouterSujet(prefixe, rappel) {
  const e = { prefixe: String(prefixe ?? ""), rappel };
  ecouteurs.add(e);
  return () => ecouteurs.delete(e);
}

function appeler(e, evt) {
  try {
    e.rappel(evt);
  } catch {
    /* un écouteur fautif ne coupe ni le flux ni les autres écrans */
  }
}

/** Appelé par le lecteur du flux pour chaque trame `event: sujet`. */
export function diffuserSujet(data) {
  const sujet = data?.sujet;
  if (typeof sujet !== "string" || sujet === "") return;
  for (const e of [...ecouteurs]) {
    if (sujet.startsWith(e.prefixe)) appeler(e, { sujet, resync: false, data });
  }
}

/** Appelé quand le serveur ne peut plus rejouer : chaque écouteur relit sa vue. */
export function diffuserResync() {
  for (const e of [...ecouteurs]) appeler(e, { sujet: null, resync: true, data: null });
}

/** Tests uniquement. */
export function _viderEcouteurs() {
  ecouteurs.clear();
}
